var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110.04,
    height: 107.5,
    viewBox: "0 0 88.030066 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.04 0h5.94v8c10.01 0 20.02 0.02 30.03-0.03 1.69 0.07 3.55-0.05 5.02 0.96 1.03 1.48 0.91 3.36 0.98 5.06-0.05 17.36-0.03 34.71-0.02 52.06-0.05 2.91 0.27 5.88-0.34 8.75-0.4 2.08-2.9 2.13-4.57 2.2-10.36 0.03-20.73-0.02-31.1 0v9h-6.21c-15.24-2.77-30.51-5.33-45.77-8v-69.99c15.35-2.67 30.7-5.3 46.04-8.01z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51.98 11h33v63h-33v-6h8v-7h-8v-4h8v-7h-8v-4h8v-7h-8v-4h8v-7h-8v-4h8v-7h-8v-6z",
    fill: "#051f42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m63.98 17h14v7h-14v-7z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29.62 26.37c2.26-0.16 4.53-0.3 6.8-0.41-2.67 5.47-5.35 10.94-8.07 16.39 2.75 5.6 5.56 11.16 8.32 16.76-2.41-0.14-4.81-0.29-7.22-0.46-1.7-4.17-3.77-8.2-4.99-12.56-1.36 4.06-3.3 7.89-4.86 11.87-2.19-0.03-4.38-0.12-6.57-0.21 2.57-5.03 5.05-10.1 7.7-15.1-2.25-5.15-4.72-10.2-7.04-15.32 2.2-0.13 4.4-0.26 6.6-0.38 1.49 3.91 3.12 7.77 4.35 11.78 1.32-4.25 3.29-8.25 4.98-12.36z",
    fill: "#051f42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m63.98 28h14v7h-14v-7z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m63.98 39h14v7h-14v-7z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m63.98 50h14v7h-14v-7z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m63.98 61h14v7h-14v-7z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelLogo);
export default __webpack_public_path__ + "static/media/excel-logo.4659568ea53a806197e3d05215882bb3.svg";
export { ForwardRef as ReactComponent };